<template>
    <div class="createcmgt spackage padding-20 bgc box-shadow" v-loading="loading">
        <section style="width: 811px;">
            <h1>基本信息</h1>
            <el-form :model="cmgtFormData" :rules="rules" ref="cmgtFormData" label-width="100px" class="starmgt-form">
                <el-form-item label="社群名称" prop="assname">
                    <el-input v-model="cmgtFormData.assname" placeholder="请输入社群名称，不超过20个字" maxlength="20"></el-input>
                </el-form-item>

                <el-form-item label="社群分组" prop="groupinnerid">
                    <el-select v-model="cmgtFormData.groupinnerid" placeholder="请选择社群分组" :loading="loadingStatus">
                        <el-option v-for="item in cClassify" :label="item.name" :value="item.innerid" :key="item.name"></el-option>
                    </el-select>
                    <span class="add_classify" @click="jumpToList">添加分组</span>
                </el-form-item>

                <el-form-item label="社群头像" prop="logoatturlid" class="upload-image" required>
                    <div class="upload">
                        <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                    </div>
                   <div class="position">
                       <!-- <el-button plain>选择文件</el-button> -->
                       <p>建议尺寸350*350px的JPG、PNG格式，不超过2M</p>
                   </div>
                </el-form-item>

                <el-form-item label="订单验证" prop="ismobilevalid">
                    <el-switch v-model="cmgtFormData.ismobilevalid"></el-switch>
                    <span class="txt" style="margin-left: 15px;">开启后需进行手机验证</span>
                </el-form-item>

                <el-form-item label="社群介绍" prop="desp">
                    <el-input type="textarea" v-model="cmgtFormData.desp" autocomplete="off" placeholder="请输入社群介绍，不超过200个字"></el-input>
                </el-form-item>

                <h1>拉新设置</h1>

                <el-form-item label="社群拉新" prop="isopen">
                    <el-switch v-model="cmgtFormData.isopen"></el-switch>
                    <span class="txt" style="margin-left: 15px;">有助于社群的营销推广</span>
                    <p>
                        <span style="color: #666">拉新返现将从商家账号余额进行扣款</span>
                        <el-button type="text" @click="checkRemainMoney">查看余额</el-button>
                    </p>
                </el-form-item>

                <el-form-item v-if="cmgtFormData.isopen" label="奖励类型" prop="rewardtype">
                    <el-radio-group v-model="rewardtype">
                        <el-radio v-for="item in awardtypeList" :label="item.key">{{item.label}}</el-radio>
                    </el-radio-group>
                    <div class="award_type">
                        <div v-if="rewardtype === 1" class="discount_coupon">
                            <div class="a_money">
                                <span>优惠金额</span>
                                <p>
                                    <span>满</span>
                                    <el-input v-model="cmgtFormData.minordermoney" placeholder="输入整数"></el-input>
                                    <span>减</span>
                                    <el-input v-model="cmgtFormData.faceprice" placeholder="输入整数"></el-input>
                                </p>
                            </div>
                            <div class="period">
                                <span>有效期</span>
                                <p>
                                    <span>发放后</span>
                                    <el-input v-model="cmgtFormData.expiredays" placeholder="输入整数"></el-input>
                                    <span>天内有效</span>
                                </p>
                            </div>
                        </div>
                        <div v-else class="return_money">
                            <div>
                                <span>返现金额</span>
                                <el-input v-model="cmgtFormData.rewardmoney" placeholder="输入整数"></el-input>
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <h1>门店信息</h1>

                <el-form-item label="门店名称" prop="shopname">
                    <el-input v-model="cmgtFormData.shopname" placeholder="请输入门店名称，不超过20个字" maxlength="20"></el-input>
                </el-form-item>

                <el-form-item label="门店logo" prop="shoplogourl" class="upload-image">
                    <div class="upload">
                        <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setShopCoverfile" :uploadType="uploadType" ref="coverfileShop"></upload>
                    </div>
                   <div class="position">
                       <!-- <el-button plain>选择文件</el-button> -->
                       <p>建议尺寸350*350px的JPG、PNG格式，不超过2M</p>
                   </div>
                </el-form-item>

                <el-form-item label="门店电话" prop="shoptel">
                    <el-input v-model="cmgtFormData.shoptel" placeholder="请输入门店有效联系电话"></el-input>
                </el-form-item>

                <el-form-item label="门店地址" prop="shopaddress">
                    <div @click="showLocationDialog">
                        <el-input v-model="cmgtFormData.shopaddress" placeholder="点击设置门店地址" :disabled="isDisabled"></el-input>
                    </div>
                </el-form-item>

                <el-form-item label="营业时间" prop="shoptimeinfo">
                    <el-input v-model="cmgtFormData.shoptimeinfo" placeholder="请输入门店营业时间"></el-input>
                </el-form-item>

                <el-form-item label="门店介绍" prop="shopdesp">
                    <el-input type="textarea" v-model="cmgtFormData.shopdesp" autocomplete="off" placeholder="请输入门店介绍，不超过200个字"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="cancel">取消</el-button>
                    <el-button v-if="type !== 'delete'" type="primary" @click="submitForm('cmgtFormData')" style="margin-left: 20px;">提交</el-button>
                </el-form-item>
            </el-form>
        </section>

        <!-- 新增分组 弹窗 -- start -->
        <el-dialog title="添加分组" :visible.sync="dialogFormVisible" @close="cancelCE" class="create_edit_dialog">
            <el-form :model="ggFormData" :rules="rules" ref="ggFormData">
                <el-form-item label="分组名称" :label-width="formLabelWidth" prop="name" required>
                    <el-input type="text" v-model="ggFormData.name" minLength="1" maxLength="8" autocomplete="off" placeholder="输入分组名称，不超过8个字" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <el-form :model="form">
                <el-form-item label="分组说明" :label-width="formLabelWidth" prop="memo">
                    <el-input type="textarea" :rows="4" v-model="ggFormData.memo" maxLength="80" autocomplete="off" placeholder="输入分组说明，不超过80个字" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelCE">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 新增分组 弹窗 -- end -->

        <ChooseLocation :locationDialog="locationDialogStatus" @close="locationDialogStatus=false" @thePosition="getThePosition" />
    </div>
</template>

<script>
import {getMaterialsInfo, searchAssociationList, saveOrUpdateAssociations, getAssociationsInfo, getAgbCommGroupSimpleList, saveOrUpdateCommGroup} from '@/api/cPurchaseApi'
import Upload from 'base/upload/upload'
import UploadFile from 'base/upload/uploadFile'
import UEditor from 'base/uEditor/uEditor'
import {mapActions} from 'vuex'
import {getCookie,formatFileInfo} from '@/common/js/tools'
import $ from 'jquery'
import ChooseLocation from './components/chooseLocation'

export default {
    name: "createCMgt",
    data() {
        let validatelogodata = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请商品图片'))
            } else {
                callback()
                if(value.furl) {
                    this.cmgtFormData.logodata = value.furl
                }
            }
        }
        return {
            form: {},
            loading: false,
            token: getCookie('token'), // token
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            innerid: this.$route.query.innerid ? this.$route.query.innerid : '',
            type: this.$route.query.type,
            imgUrl: "http://img.capwhale.com/mp/bg/", // 服务器头像图片url
            cClassify: [],
            imageUrl: '',
            rewardtype: 1,
            cmgtFormData:{
                assname: '', // 社群名称
                logoattid: '', // 社群头像id
                logoatturlid: '', // 社群头像
                groupinnerid: '', // 社群分组id
                groupname: '', // 社群分组名称
                ismobilevalid: false, // 是否订单
                desp: '', // 社群介绍
                isopen: true, // 是否社群拉新
                rewardtype: 1, // 奖励类型 1优惠券 2直接返现
                rewardmoney: '', // 返现金额
                faceprice: '', // 优惠金额
                minordermoney: '', // 优惠满多少使用
                expiredays: '', // 发放后多少天有效
                shopname: '', // 门店名称
                shoplogoid: '', // 门店logoid
                shoplogourl: '', // 门店logo
                shoptel: '', // 门店电话
                shopaddress: '', // 门店地址
                shoptimeinfo: '', // 营业时间说明
                shopdesp: '' // 门店介绍
            },
            awardtypeList: [
                {
                    label: '优惠券',
                    key: 1
                },
                {
                    label: '直接返现',
                    key: 2
                }
            ],
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: '',
                height: ''
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            rules: {
                assname: [
                    { required: true, message: '请输入社群名称', trigger: 'blur' }
                ],
                groupinnerid: [
                    { required: true, message: '请选择社群分组', trigger: 'blur' }
                ]
            },
            updateImgStatusC: false, // 更改图片操作状态 true 更改 false 未更改
            updateImgStatusShop: false,  // 更改图片操作状态 true 更改 false 未更改
            locationDialogStatus: false, // 门店地址选择弹窗
            isDisabled: true,
            ggFormData: {
                name: '',
                memo: ''
            },
            formLabelWidth: '80px',
            dialogFormVisible: false,
            loadingStatus: true
        }
    },
    created() {
        this.getGCList()
    },
    mounted() {
        if (this.innerid) {
            this.getCInfo()
        }
    },
    methods: {
        // 获取社群分组列表
        getGCList() {
            getAgbCommGroupSimpleList({
                success: data => {
                    if (data.data.content) {
                        this.loadingStatus = false
                        let resData = data.data.content
                        this.cClassify = resData
                    }
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 获取社群信息
        getCInfo() {
            let data = {
                assinnerid: this.innerid
            }
            this.setLoading(true)
            getAssociationsInfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    let resData = data.data

                    this.cmgtFormData.assname = resData.assinnername
                    this.cmgtFormData.logoatturlid = resData.logoatturlid
                    this.cmgtFormData.groupinnerid = resData.groupInnerid
                    this.cmgtFormData.groupname = resData.groupname
                    this.cmgtFormData.desp = resData.desp
                    this.cmgtFormData.ismobilevalid = resData.ismobilevalid ? true : false
                    this.cmgtFormData.isopen = resData.isopen ? true : false
                    this.cmgtFormData.rewardtype = resData.rewardtype
                    this.rewardtype = resData.rewardtype
                    this.cmgtFormData.rewardmoney = resData.rewardmoney
                    this.cmgtFormData.faceprice = resData.faceprice
                    this.cmgtFormData.minordermoney = resData.minordermoney
                    this.cmgtFormData.expiredays = resData.expiredays
                    this.cmgtFormData.shopname = resData.shopname
                    this.cmgtFormData.shoplogourl = resData.shoplogourl
                    this.cmgtFormData.shoptel = resData.shoptel
                    this.cmgtFormData.shopaddress = resData.shopaddress
                    this.cmgtFormData.shoptimeinfo = resData.shoptimeinfo
                    this.cmgtFormData.shopdesp = resData.shopdesp

                    // 设置图片回填 coverfileShop
                    this.$refs.coverfile.setImage(this.cmgtFormData.logoatturlid)
                    this.$refs.coverfileShop.setImage(this.cmgtFormData.shoplogourl)
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 添加社群分组
        jumpToList() {
            // this.$router.push({ name: 'groupGrouping', query: {}})
            this.dialogFormVisible = true
        },

        // 取消创建分组
        cancelCE() {
            this.dialogFormVisible = false
            this.ggFormData.name = ''
            this.ggFormData.memo = ''
        },

        // 新增分组 接口调用
        sureAdd() {
            this.setLoading(true)
            let data = {
                name: this.ggFormData.name,
                memo: this.ggFormData.memo
            }
            saveOrUpdateCommGroup({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.dialogFormVisible = false
                    this.ggFormData.name = ''
                    this.ggFormData.memo = ''
                    this.$message.success('分组添加成功')
                    this.getGCList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        
        updateimg() {
            let reads = new FileReader(),
                file = document.getElementById('file').files[0],
                isJPG,
                $this = this
            const isLt2M = file.size / 1024 / 1024 < 2;
            if(file.type === 'image/jpeg' || file.type === 'image/png') {
                isJPG = true
            } else {
                isJPG = false
            }

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 jpg/png 格式!')
                return false
            }

            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!')
                return false
            }

            reads.readAsDataURL(file);

            reads.onload = function(){

                $this.cmgtFormData.logodata = $this.imageUrl = this.result
                // 重置头像
                $("input[name=headerimg]:checked").prop('checked',false)
            }
        },

        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    let updata = JSON.parse(JSON.stringify(this.cmgtFormData))
                    
                    updata.assinnerid = this.innerid

                    for (let item in this.cClassify) {
                        if (this.cClassify[item].innerid === updata.groupinnerid) {
                            updata.groupname = this.cClassify[item].name
                        }
                    }

                    updata.ismobilevalid = updata.ismobilevalid ? 1 : 0
                    updata.isopen = updata.isopen ? 1 : 0
                    updata.rewardtype = this.rewardtype
                    console.log(updata)

                    // 当头像图片发生变更时
                    // if( this.updateImgStatus ) {
                    //     updata.logodata.type = 'add'
                    //     updata.logodata = formatFileInfo(updata.logodata)
                    // } else {
                    //     updata.logodata = ''
                    // }

                    this.setLoading(true)

                    saveOrUpdateAssociations({
                        data: updata,
                        success: data => {
                            this.$message.success('保存成功')
                            this.setLoading(false)
                            this.$router.back()
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false;
                }
            });
        },

        // 设置社群头像信息（本地）
        setCCoverfile(img) {
            // 发生头像图片变更操作
            this.updateImgStatusC = true
            $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
            this.cmgtFormData.logoatturlid = img.furl
            this.cmgtFormData.logoattid = img.key
        },

        // 设置门店logo信息 （本地）
        setShopCoverfile(img) {
            this.updateImgStatusShop = true
            $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
            this.cmgtFormData.shoplogourl = img.furl
            this.cmgtFormData.shoplogoid = img.key
        },

        // 取消
        cancel() {
            this.$router.push({ name: 'mOPIndex'})
        },

        // 选择地址
        showLocationDialog() {
            this.locationDialogStatus = true
        },

        getThePosition(data) {
            console.log(data)
            this.cmgtFormData.shopaddress = data
            this.locationDialogStatus = false
        },

        // 查看余额
        checkRemainMoney() {
            let route = this.$router.resolve({ name: 'FManagement'})
            window.open(route.href, '_blank')
        },

        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        Upload,
        UploadFile,
        UEditor,
        ChooseLocation
    }
}
</script>

<style lang="scss" type="text/scss"  rel="stylesheet/scss">
    .createcmgt {
        .create_edit_dialog {
            .el-dialog {
                width: 550px;
                height: 350px;
            }
            .el-dialog__body {
                padding: 20px 20px 0 20px;
            }
            .el-dialog__footer {
                padding: unset;
            }
            .el-input,
            .el-input__inner {
                width: 420px;
            }
            .el-textarea textarea {
                width: 420px;
                height: 130px;
                resize: none;
            }
        }
        .award_type {
            .discount_coupon {
                .a_money, .period {
                    display: flex;
                    justify-content: space-between;
                    width: 350px;
                    >p {
                        display: flex;
                        justify-content: space-between;
                        width: 250px;
                        .el-input {
                            width: 90px;
                        }
                    }
                    .el-input__inner {
                        width: 90px;
                    }
                }
                .period {
                    p {
                        // justify-content: flex-start;
                    }
                }
            }
            .return_money {
                div {
                    display: flex;
                    justify-content: space-between;
                    width: 270px;
                    .el-input {
                        width: 200px;
                    }
                }
            }
        }
        .add_classify {
            font-size: 14px;
            color: #409EFF;
            margin-left: 15px;
            cursor: pointer;
        }
        .headerimg {
            margin-right: -10px;
            label {
                position: relative;
                display: inline-block;
                cursor: pointer;
                margin-right: 10px;
                margin-bottom: 10px;
                width:110px;
                height:65px;
                box-sizing: border-box;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            input[type=radio]:checked + label {
                border: solid 1px #409EFF;
            }

            input[type=radio]:checked + label:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                width: 23px;
                height: 23px;
                background: url("../../../common/images/starMgtHeaderimg/radio.png") no-repeat center ;
                background-size: 23px;
            }
            .btn {
                margin-top: 20px;
                text-align: center;
            }
        }
        h1 {
            margin: 20px 0;
            padding-left: 8px;
            color: #303133;
            font-weight: 500;
            font-size: 16px;
            border-left: solid 2px #409EFF;
        }
        .el-input__inner {
            width: 400px;
        }
        .el-input__prefix, .el-input__suffix {
            height: auto;
        }
        .el-form-item__label {
            text-align: left;
        }
        .upload {
            float: left;
            margin-right: 15px;
        }
        .idcardImage .avatar-uploader{
            box-sizing: border-box;
            width: 170px;
            height: 170px;
        }

        .avatar {
            width: 100%;
            height: 126px;
            display: block;
        }

        .el-textarea textarea {
            width: 400px;
            height: 105px;
            resize: none;
        }

        .position {
            margin-top: 45px;
            p {
                color: #C0C4CC;
                font-size: 14px;
            }
        }

        .switch-text,
        .el-switch {
            float: left;
        }
        .el-switch {
            margin-top: 10px;
        }
        .switch-text p {
            margin-left: 20px;
            color: #909399;
            font-size: 14px;
        }
        .avatar-uploader .el-upload {
            width: 130px;
            height: 130px;
            border: 1px dashed #d9d9d9;
            border-radius: unset;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .icon_upload:before {
            background-size: 30%;
            background-position: center;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 212px;
            height: 126px;
            line-height: 178px;
            text-align: center;
        }
    }
</style>
